import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import LoadingButton from '@mui/lab/LoadingButton';
import Dialog from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';
import { utmsButtonSx } from '@shared/constants/otherConstants';
import UtmsButton from '@shared/components/ui/UtmsButton';

const ModalSimple = ({
    open,
    action,
    content,
    title,
    handleClose,
    handleSubmit,
    isLoading,
    customActions,
    submitButtonIcon,
    disabledButton,
    DialogProps,
}) => {
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={handleClose} {...DialogProps}>
            <DialogTitle variant="h4" onClick={(e) => e.stopPropagation()}>
                {title}
            </DialogTitle>
            <DialogContent onClick={(e) => e.stopPropagation()}>{content}</DialogContent>
            <DialogActions
                onClick={(e) => e.stopPropagation()}
                sx={{
                    padding: '18px 24px',
                    justifyContent: 'flex-end',
                }}
            >
                {customActions}
                <LoadingButton
                    sx={utmsButtonSx}
                    endIcon={submitButtonIcon}
                    onClick={handleSubmit}
                    loading={isLoading}
                    loadingPosition={submitButtonIcon && 'end'}
                    tabIndex={0}
                    disabled={disabledButton}
                >
                    {action || t('create')}
                </LoadingButton>
                {handleClose && (
                    <UtmsButton color="secondary" onClick={handleClose} tabIndex={1}>
                        {t('cancel')}
                    </UtmsButton>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default ModalSimple;
